require('./angular-cookies');
module.exports = 'ngCookies';



//////////////////
// WEBPACK FOOTER
// ./~/angular-oauth2/~/angular-cookies/index.js
// module id = 51
// module chunks = 1